import request from '@/config/request'

export function getSearchDisc(dicType) {
    return request.get(`/commonserver/dict/listDictDataByType/${dicType}`)
}
export function getPageList(params) {
    return request.get('/courseserver/course/pageProvinceBoutiqueCourse', { params })
}

export function getPageListGuest(params) {
    return request.get('/courseserver/course/pageTouristsCourse', { params })
}

export function getPageDetail(id) {
    return request.get(`/courseserver/course/provinceBoutiqueCourseDetail/${id}`)
}

export function getPageDetailGuest(id) {
    return request.get(`/courseserver/course/touristsCourseDetail/${id}`)
}

export function getPlayAuth(videoId) {
    return request.get(`/commonserver/video/getPlayAuth/${videoId}`)
}
export function getSystemConfig() {
    return request.get('/commonserver/system/config')
}
export function getRecommendCourse(params) {
    return request.get('/courseserver/course/recommendCourse', { params })
}

export function getLessonResourceToken(pptId) {
    const params = {
        timeStamp: Date.now()
    }
    return request.get(`/commonserver/eppt/getPlayAuth/${pptId}`, { params })
}

export function getLessonResource(params) {
    return request.post('/courseserver/courseLesson/listLessonResource', params)
}

export function getDownloadUrl(params) {
    return request.post('/courseserver/courseLesson/getDownloadUrl', params)
}

export function downloadSource(params) {
    return request.post('/courseserver/courseLesson/downloadFile', params)
}
export function downloadSubjectSource(params) {
    return request.post('/courseserver/courseTeachingAuxiliary/downloadFile', params)
}

export function getTopicList(params) {
    return request.get('/courseserver/tTopic/list', { params })
}

export function getTopicCourseList(params) {
    return request.get('/courseserver/tTopicCourse/listTeacherTeaching', { params })
}

export function getSubDisc(teachingAuxiliaryId) {
    return request.get(`/courseserver/courseTeachingAuxiliary/getBookDicData/${teachingAuxiliaryId}`)
}
export function getSubDiscByGroup(teachingAuxiliaryId) {
    return request.get(`/courseserver/courseTeachingAuxiliary/getBookDicDataByGroup/${teachingAuxiliaryId}`)
}

export function getSubDetail(courseId, teachingAuxiliaryId) {
    return request.get(`/courseserver/courseTeachingAuxiliary/info/${courseId}/${teachingAuxiliaryId}`)
}

export function getBookDisc(params) {
    return request.get(`/courseserver/courseTeachingAuxiliary/listCourseBook`, { params })
}

export function getBookChapter(textbookId) {
    return request.get(`/courseserver/courseTeachingAuxiliary/getChapterTree/${textbookId}`)
}

export function getBookChapterResource(textbookId, chapterId) {
    return request.get(`/courseserver/courseTeachingAuxiliary/listResourceByChapterId/${textbookId}/${chapterId}`)
}

export function getListTeachingClass(courseId, date) {
    return request.get(`/courseserver/teacherTeaching/listTeachingCourse?courseId=${courseId}${date ? `&day=${date}` : ''}`)
}

// feedback
export function getCourseFeedbackData(courseId) {
    return request.get(`/courseserver/course/userCourseOperation/${courseId}`)
}

export function getTouristsCourseFeedbackData(courseId) {
    return request.get(`/courseserver/course/touristsCourseOperation/${courseId}`)
}

export function setCourseFeedbackRate(courseId, value) {
    return request.post('/courseserver/userComment/comment', {
        targetId: courseId,
        targetType: 'course',
        scoreLevel: value,
    })
}
export function setCourseFeedbackFavorite(courseId, value = true) {
    const func = value ? 'favorite' : 'unFavorite'
    const url = `/courseserver/userFavorite/${func}`
    return request.post(url, {
        targetId: courseId,
        targetType: 'course',
    })
}
export function setCourseFeedbackLike(courseId, value = true) {
    const func = value ? 'like' : 'unlike'
    const url = `/courseserver/userLike/${func}`
    return request.post(url, {
        targetId: courseId,
        targetType: 'course',
    })
}

export function updateCourseViewCount(courseId) {
    return request.post('/courseserver/course/updateCourseViewCount', {
        courseId,
    })
}

export function updateTouristsCourseViewCount(courseId) {
    return request.post('/courseserver/course/touristsUpdateCourseViewCount', {
        courseId,
    })
}

export function commitSuggestion(params) {
    return request.post(`/courseserver/userSuggestion/suggestion`, params)
}

export function hasFavorite(targetType, targetId) {
    return request.get(`/courseserver/userFavorite/hasFavorite?targetType=${targetType}&targetId=${targetId}`)
}

//v4.3.0 在首页获取课程

//首页
//广告
export function getHomeAdBanner(adSpaceId) {
    return request.get(`/commonserver/ad/queryList/${adSpaceId}`)
}
//登录模式
export function getHomeCourseList() {
    return request.get(`/courseserver/course/homeProvinceCourseByType`)
}

//游客模式
export function getGuestHomeCourseList() {
    return request.get(`/courseserver/course/visitorHomeProvinceCourseByType`)
}

//课程查询列表
export function getProvinceType() {
    return request.get(`/commonserver/dict/getProvinceCourseTypeDicData`)
}

//搜索资源
export function searchResource(params) {
    return request.post('/courseserver/teacherTeaching/search', params)
}

//游客模式搜索资源
export function visitorSearchResource(params) {
    return request.post('/courseserver/teacherTeaching/visitorSearch', params)
}

//获取搜索历史
export function getSearchHistory(limit = 5) {
    return request.get(`/courseserver/searchHistory/list?limit=${limit}`)
}

//删除搜索历史      默认情况下清除所有历史记录
export function deleteHistory(ids = "") {
    return request.get(`/courseserver/searchHistory/delete?ids=${ids}`)
}

//搜索页根据资源id获取资源信息
export function getResourceInfo(channel = "", channelResourceId = "") {
    return request.get(`/courseserver/teacherTeaching/queryResource?channel=${channel}&channelResourceId=${channelResourceId}`)
}
